{
  "Account Alone Using Credential": "Solo hay una cuenta usando esta credencial",
  "Account Alone Using Remote": "Solo hay una cuenta usando este remoto",
  "Account Not Exists": "La cuenta introducida no existe",
  "Accounts": "Cuentas",
  "Accounts Must Not Be Maestronet": "El login no puede ser 'maestronet' para un usuario aerolínea",
  "Accounts Using Credential Count": "Hay {{ count }} cuentas usando esta credencial",
  "Accounts Using Remote Count": "Hay {{ count }} cuentas usando este remoto",
  "Actions": "Acciones",
  "Active Users": "Usuarios Activos",
  "Add New Accounts To User": "Añadir nuevas cuentas al usuario",
  "Agency": "Agencia de viajes",
  "Agency Role Must Be Unique Role": "Rol de agencia debe de ser único rol",
  "Agent": "Agente",
  "Agents": "Agentes",
  "Agents Groups": "Grupos Agentes",
  "Airline": "Aerolínea",
  "airline": "aerolínea",
  "Airline Already Exists": "Alguna aerolínea introducida ya está asociada a otro cliente",
  "Airline Code": "Código de aerolínea ",
  "Airline Not Belong Customer": "La aerolínea de esta cuenta no pertenece a este cliente",
  "Airline Three Digits": "El formato de aerolínea deben ser 3 dígitos",
  "Airline In": " aerolínea en ",
  "Airlines In": " aerolíneas en ",
  "Airlines & Countries": "Aerolineas y Países",
  "Agent Macro Group": "Macro grupo de agentes",
  "ALL": "TODAS",
  "ALL MALE": "TODOS",
  "ALL FEMALE": "TODAS",
  "All Countries": "Todos los países",
  "All Customers": "Todos los clientes",
  "All Documents": "Todos los documentos",
  "Allowed IPs": "IP's permitidas",
  "Allowed Types Files": "Tipos de ficheros permitidos: {{ allowedTypesFiles }}",
  "Amount": "Importe",
  "Apply": "Aplicar",
  "Apps": "Aplicaciones",
  "arc": "ARC",
  "ARM Communication": "Comunicación de ARM",
  "Assigned": "Asignado/a",
  "Assigned To": "Asignada a",
  "AssignedTooTo": "Asignada también a",
  "Attachments": "Adjuntos",
  "Attachment Long Size": "El tamaño del fichero supera el límite ({{ quantityMax }}MB). Por favor, genere un informe con un periodo menor (desde.. hasta..)",
  "Awaiting feedback": "Esperando respuesta",
  "Back": "Atrás",
  "body": "mensaje",
  "Body": "Mensaje",
  "Body Characters Minimum Communications": "El cuerpo debe tener al menos 5 caracteres",
  "Body Message": "Cuerpo del mensaje",
  "Body Message Required": "Cuerpo mensaje requerido",
  "BookingClasses": "Clases",
  "bsp": "BSP",
  "BSP Not Found Airline Customer": "El BSP no se encuentra la aerolínea de este cliente",
  "Change User Password": "¿Está seguro de que quiere cambiar la contraseña del usuario?",
  "Check Email IPM": "Ha ocurrido un error obteniendo la información de los clientes. Por favor, revise el email de soporte",
  "Choose one country": "Elija al menos un país",
  "Choose One Product To Continue": "Se debe seleccionar al menos un producto para continuar",
  "Closed": "Cerrado",
  "Closed Date": "Fecha de Cierre",
  "Comment Required If Verified": "No se puede cambiar el estado a 'Verificado' sin un comentario",
  "Comment Saved Correctly": "El comentario se ha añadido a la comunicación",
  "Comments": "Comentarios",
  "comments": "comentarios",
  "Commissioned Tickets": "Billetes Comisionados",
  "Commission": "Comisión",
  "Commissions": "Comisiones",
  "Communication Details": "Detalles de la comunicación",
  "Communication Updated Correctly": "La comunicación ha sido actualizada correctamente",
  "Communication Sent": "La comunicación ha sido enviada",
  "Communications Limited": "Los resultados de la búsqueda se limitan a las 1000 comunicaciones más recientes.",
  "Compare": "Comparar",
  "Compare Deal": "Comparar",
  "Confirm Password Is Not The Same": "La contraseña de confirmación no es la misma que la nueva contraseña",
  "Confirmation": "Confirmación",
  "Consider Following": "Tenga en cuenta lo siguiente",
  "Connection Extra Parameters": "Parámetros extra de conexión",
  "Contact Email": "Email de contacto",
  "Contact Name": "Nombre de contacto",
  "Contact Phone": "Teléfono de contacto",
  "Contact With Support": " y póngase en contacto con soporte",
  "Content": "Contenido",
  "Contract Code": "Código de acuerdo",
  "Contract Code Already Exists": "Ya existe una comunicación con estado no-cerrado para este código de contrato, cliente y país",
  "Contract Code Error": "Los siguientes caracteres no pueden ser usados: espacio( ), comilla simple('), comilla doble(\") y ampersand(&)",
  "Contract Code Required": "No se puede guardar una comunicación del tipo solicitud de contrato sin un país asociado",
  "Contract Management Login": "Acceso con éxito con  ",
  "Contract Name Description": "Descripción de contrato",
  "Contract Request": "Solicitud de contrato",
  "Contracts": "Contratos",
  "Conversion": "Convertir a:",
  "Countries": "Países",
  "Countries And Airlines": "Países y aerolíneas",
  "Countries Space": " países",
  "Country": "País",
  "Country Space": " país",
  "Country Not Belong Customer": "El país de esta cuenta no pertenece a este cliente",
  "Country Two Characters": "El formato del país debe tener 2 caracteres (dígitos -0-9- y/o letras mayúsculas -A-Z-)",
  "Create": "Crear",
  "Create Account": "Crear cuenta",
  "Create Association Per Product": "Hay que crear al menos una asociación por producto: [ ' {{ currentProduct }} ' ] no tiene ninguno. Por favor, comprueba la pestaña 'Países y aerolíneas'",
  "Create Maestro Account": "Crear cuenta Net remit Maestronet",
  "Create New Account": "Crear nueva cuenta",
  "Create New Credential": "Crear nueva credencial",
  "Create New Remote": "Crear nuevo remoto",
  "Created by": "Creado por",
  "Credential": "Credencial",
  "Credential Description": "Descripción de la credencial",
  "Credential Updated": "Credencial actualizada correctamente",
  "CRM": "CRM",
  "Currencies": "Monedas",
  "Currency": "Moneda",
  "Customer": "Cliente",
  "CustomerId Required To Admin": "El id del cliente es obligatorio siendo administrador",
  "Customer Not Found" : "Ha ocurrido un problema al obtener la información del cliente. Por favor, póngase en contacto con soporte",
  "Customer Reference": "Referencia de cliente",
  "Customer Reference Error": "Solamente se admiten carácteres alfanuméricos",
  "Customers": "Clientes",
  "Customers Administration": "Administración de Clientes",
  "Data In File": "* Incluidos en el fichero",
  "Date Closure": "Fecha de Cierre",
  "Day Month": "Día de mes",
  "Day Week": "Día de semana",
  "Days": "días",
  "Deal Comparison": "Comparación de acuerdos",
  "Destination": "Destino",
  "Description": "Descripción",
  "Delete": "Eliminar",
  "Delete Maestronet Account": "Eliminar cuenta de maestronet",
  "Details": "Detalles",
  "DB Connections": "Conexiones BBDD",
  "db-ifx": "Informix",
  "db-ss": "Sql server",
  "Disabled": "Deshabilitado",
  "Discarded": "Descartado",
  "Display days": "* Visualización limitada a los últimos {{maxDaysInGraphics}} días de la selección",
  "Display months": "* Visualización limitada a 3 meses",
  "Documentation Message" : "Pulse para obtener información sobre ",
  "Download": "Descargar",
  "Download Doc": "Descarga Doc",
  "Download Graphic" : "Descargar gráfico",
  "Download Response File" : "Descargar fichero de respuesta",
  "Download Sent File" : "Descargar fichero enviado",
  "Due Date": "Fecha Límite",
  "Duplicated Account": "Cuenta duplicada. Por favor, introduzca una diferente",
  "Edit Credential": "Editar credencial",
  "Edit Remote": "Editar remoto",
  "Edit User Profile": "Editar perfil usuario",
  "Email": "Email",
  "Email Required": "El email es obligatorio",
  "Email Sent Correctly": "Email enviado correctamente",
  "Email Separator": "El separador válido entre emails es punto y coma (;), coma (,) o espacio",
  "Enabled": "Habilitado",
  "endTaskDateError:Incorrect EndTaskDate. Higher Equal Extraction Start Date": "Fin de extracción incorrecta: debe ser mayor o igual que la inicio de extracción",
  "endTaskDateError:Incorrect EndTaskDate. Higher Equal Today": "Fin de extracción incorrecta: debe ser mayor o igual que hoy",
  "entries": "Entradas",
  "Error Analytics":"Ha ocurrido un error mientras se procesaba su solicitud, por favor revise su configuración de analytics",
  "Error Cancelling Payment":"Ha ocurrido un error en la cancelación del pago",
  "Error Communication Saved":"No se pueden modificar el país o el código de acuerdo una vez que la comunicación ha sido tratada por la WS-API",
  "Error Creating Threshold Contract": "Se ha producido un error al intentar guardar el acuerdo de objetivos",
  "Error File Download": "Se ha producido un error al intentar descargar el fichero. Por favor, póngase en contacto con soporte",
  "Error Generic": "Se ha producido un error inexperado. Por favor, póngase en contacto con soporte",
  "Error Generic Onload": "Se ha producido un error al cargar los datos de la página. Por favor, póngase en contacto con soporte",
  "Error Getting Communication": "Error al obtener la información de la comunicación",
  "Error Invalid Form": "No se puede guardar esta comunicación debido a errores en el formulario",
  "Error Loading MacroGroups File": "Se ha producido un error al intentar cargar el fichero de macro-grupos",
  "Error No Enabled Database For Country": "No hay ninguna base de datos asociada a ese país",
  "Error On Request":"Ha ocurrido un error al intentar realizar esta operación",
  "Error Search Graphic": "La búsqueda ha fallado",
  "Error User": "La búsqueda ha fallado buscando los datos de usuario",
  "Error Updating Status File": "Error al actualizar el estado del fichero. Por favor, póngase en contacto con soporte",
  "Error Updating Task": "Se ha producido un error al actualizar la plantilla de la tarea",
  "Error ThresholdContracts Delete": "Se ha producido un error al borrar un contrato de objetivos",
  "Error ThresholdContract Not Found": "Contrato de objetivos no encontrado",
  "Esmash Request": "Solicitud Esmash",
  "Excel Not Exists": "El fichero no se encuentra disponible. Por favor, vuelva a generarlo de nuevo",
  "Exclusions": "Exclusiones",
  "Expired": "La contraseña ha caducado. Haga click en 'Olvidé mi contraseña' para recibir una nueva",
  "Expire Date": "Fecha de expiración",
  "Exports Data XLSX": "Exportar datos como XLSX",
  "Fare": "Tarifa",
  "Farebasis": "Base de tarifa",
  "Filter": "Filtro",
  "File Masstask or ARC": "Fichero masstask / ARC",
  "File Name": "Nombre de archivo",
  "File Type": "Tipo de archivo",
  "Filter Message": "Buscar por nombre, email..",
  "Filter Records": "Filtro",
  "First Page": "Primera",
  "Flight Days": "Días de vuelo",
  "Flight Numbers": "Números de vuelo",
  "Following Errors Ocurred": "Ocurrieron los siguientes errores",
  "Following Info Ocurred": "Información",
  "Following Warning Ocurred": "Ocurrieron los siguientes avisos",
  "from": "de",
  "From": "De",
  "sftp-down": "Sftp for downloads",
  "sftp-up": "Sftp for uploads",
  "Gateway Timeout": "Conexión perdida. Por favor, verifique su conexión a internet",
  "Go Back": "Volver",
  "GNR5 Communication": "Comunicación GNR5",
  "GNR5 Customer Support": "Soporte de clientes de GNR5",
  "Groups": "Grupos",
  "Help": "Ayuda",
  "Hide Deal": "Ocultar acuerdo",
  "History": "Historial",
  "Hour": "Hora",
  "In progress": "En progreso",
  "Incorrect Alpha Numeric Simbols Format": "Admite carácteres alfanúmericos, además de guiones(-), espacios( ), puntos(.), comilla simple(') y apostrofes(´)",
  "Incorrect Alpha Numeric DISH Format": "Admite carácteres alfanúmericos según el capítulo 'Representación de datos' de DISH: A-Z 0-9 and ./-()*$\\",
  "Incorrect ContractCode Format": "Los siguientes caracteres no pueden ser usados: espacio( ), comilla simple('), comilla doble(\") y ampersand(&).",
  "Incorrect Current Password": "La contraseña actual es incorrecta.",
  "Incorrect EndTaskDate Higher Equal Extraction Start Date": "Fin de extracción incorrecta: debe ser mayor o igual que la inicio de extracción.",
  "Incorrect EndTaskDate Higher Equal Today": "Fin de extracción incorrecta: debe ser mayor o igual que hoy.",
  "Incorrect MacroGroup File Format In Line": "El formato del fichero de macro-grupos es incorrecto en la línea: ",
  "Incorrect MacroGroup File Format In Lines": "El formato del fichero de macro-grupos es incorrecto en las líneas: ",
  "Incorrect Numeric Format": "Solo números",
  "Incorrect Phone Format": "Formato de teléfono incorrecto. Carácteres que se pueden usar: números, guión(-), espacio( ), barra(/) y el operador suma(+) solamente al inicio",
  "Incorrect URL Format": "Admite carácteres alfanúmericos según el formato de URL: A-Z 0-9 y .-_~",
  "Index": "Índice",
  "Instance Name": "Nombre instancia (solo bbdd)",
  "Internal Error": "Ha ocurrido un error al intentar obtener la información para contactar. Por favor, inténtelo más tarde",
  "Internal Server Error": "Se ha producido un error inexperado. Por favor, póngase en contacto con soporte",
  "Invalid File Type": "Tipo de fichero inválido",
  "Invalid Path": "Los archivos adjuntos no se han podido cargar",
  "Invalid IsoAlpha2 Chain": "Error al obtener los clientes. Por favor, póngase en contacto con soporte",
  "Implementation": "Implementación",
  "IPM DB TimeOut": "Se ha producido un error durante la recopilación de datos. Por favor, póngase en contacto con soporte",
  "Ipm Not Properly Configured": "No se pudo acceder a la base de datos asociada con el cliente, verifique si la base de datos de IPM está configurada correctamente",
  "IPM Server Not Found": "Ocurrió un problema intentando conectar al servidor. Revise por favor la configuración de la conexión",
  "Issue": "Incidencia",
  "Issue Date": "Fecha de emisión",
  "Issue Periods": "Periodo de emisión",
  "KPI Dashboard": "Panel Control",
  "Last Page": "Última",
  "Leave": "Salir",
  "Length ContractCode": "La longitud del código de contrato debe tener un mínimo de {{ quantityMin }} caracteres y un máximo de {{ quantityMax }}",
  "Length Maximum App Name": "El tamaño máximo para el nombre de la aplicación son {{ quantityMax }} caracteres",
  "Length Maximum App Description": "El tamaño máximo para la descripción de la aplicación son {{ quantityMax }} caracteres",
  "Length Maximum Contact Email": "El tamaño máximo para el email de contacto son {{ quantityMax }} caracteres",
  "Length Maximum Contact Name": "El tamaño máximo para el nombre de contacto son {{ quantityMax }} caracteres",
  "Length Maximum Contact Phone": "El tamaño máximo para el teléfono de contacto son {{ quantityMax }} caracteres",
  "Length Maximum Customer Reference": "El tamaño máximo para la referencia del cliente son {{ quantityMax }} caracteres",
  "Length Maximum Minimum Body": "El tamaño mínimo para el 'cuerpo' son {{ quantityMin }} caracteres y máximo {{ quantityMax }}",
  "Length Maximum Minimum Cc": "El tamaño mínimo para el 'Cc' son {{ quantityMin }} caracteres y máximo {{ quantityMax }}",
  "Length Maximum Minimum Comments": "El tamaño mínimo para los comentarios son {{ quantityMin }} caracteres y máximo {{ quantityMax }}",
  "Length Maximum Minimum Current Password": "La contraseña actual tiene que tener entre 8 y 100 caracteres",
  "Length Maximum Minimum From": "El tamaño mínimo para el 'desde' son {{ quantityMin }} caracteres y máximo {{ quantityMax }}",
  "Length Maximum Minimum Login": "El tamaño máximo para el usuario son {{ quantityMax }} caracteres",
  "Length Maximum Minimum Password": "El tamaño mínimo para la contraseña son {{ quantityMin }} caracteres y máximo {{ quantityMax }}",
  "Length Maximum Minimum Subject": "El tamaño mínimo para el asunto son {{ quantityMin }} caracteres y máximo {{ quantityMax }}",
  "Length Minimum Body": "El tamaño mínimo del cuerpo del mensaje son {{ quantityMax }} caracteres",
  "Length Minimum Current Password": "El tamaño mínimo de la contraseña actual son {{ quantityMax }} caracteres",
  "Length Minimum Subject": "El tamaño mínimo del asunto son {{ quantityMax }} caracteres",
  "Length Required Country": "El tamaño para el país tiene que ser de {{ quantityMax }} caracteres",
  "Length Required Document": "El tamaño del documento tiene que ser de {{ quantityMin }} dígitos",
  "Life Span": "Duración (días)",
  "List of Contracts Is Empty": "La lista de contratos está vacía",
  "List of Contracts Not Available": "La lista de contratos no está disponible o no existe",
  "Loading": "Cargando",
  "Lock": "Desactivar",
  "Lock User": "Desactivar usuario",
  "Login Name": "Nombre de inicio de sesión",
  "Login Only Alphanumerics Dash": "El usuario solo debe contener letras, números, guión o guión bajo",
  "MacroGroups Load": "Carga de Macro-Grupos",
  "MacroGroups Load Success": "La carga del fichero de macro-grupos '{{ fileName }}' se ha realizado correctamente",
  "MaestroLogin Accounts": "Cuentas de MaestroNetLogin",
  "manual-capture-bsp": "Captura Manual BSP",
  "manual-capture-arc": "Captura Manual ARC",
  "Max 3 Files Allowed": "Máximo 3 ficheros",
  "Max Flight Date": "Fecha máxima de vuelo",
  "Maximum Months": "Máximo {{ maxMonthsAllowed }} meses",
  "Maximum Size Request": "La suma de los archivos no debe de ser superior a 28 mb",
  "MaxSelectedRangeDate": "Máximo {{maxMonthsInGraphics}} meses",
  "Max Value MaxRelated": "El valor introducido es superior al máximo",
  "Max Value MaxRelated With Detail": "El valor introducido es superior al máximo (por defecto: {{ default }}, en {{ diffCountry }} es {{ diffValue }})",
  "Memo Auditor Role Must Have Another Extra GNR5 Role": "Rol de memo auditor debe tener otro rol extra de GNR5",
  "Memo Auditor Role Must Not Be Unique Role": "Rol de memo auditor no puede ser único rol",
  "Memo Content": "Contenido del memo",
  "Memo Content Origin" : "Origen contenido memo",
  "Message Filtered From": "(filtrado de ",
  "Message Filtered Total": " registros totales)",
  "Message Info Table Showing": "Mostrando {{minValuePage}} a {{maxValuePage}} de {{total}}",
  "Message Zero Records": "No existen registros que coincidan con la búsqueda",
  "Minutes": "Minutos",
  "Mixed Conditions Not Available": "Las condiciones mixtas para este contrato no están disponibles",
  "Month": "Mes",
  "Name":"Nombre",
  "Name App":"Nombre de la aplicación",
  "Months": "meses",
  "NEW": "NUEVO",
  "New": "Nuevo",
  "New Communication": "Nueva comunicación",
  "New Credential": "Nueva credencial",
  "New Customer": "Nuevo cliente",
  "New Profile": "Nuevo perfil",
  "New Remote": "Nuevo remoto",
  "New User": "Nuevo Usuario",
  "Next From Doc": "Documento inicial",
  "Next Page": "Siguiente",
  "Next Execution": "Próxima ejecución",
  "Nobody": "Nadie",
  "None": "Ninguno",
  "No Comments": "No hay comentarios",
  "No Conversion": "No convertir",
  "No Countries": "Los países de maestronet asociados no existen en la base de datos de IPM",
  "No Data Selected Dates": "No tiene datos para los últimos {{ maxDaysInGraphics }} días seleccionados. Para ver datos en gráficas hacer Click en botón 'Semanas' o 'Meses'",
  "No Data Selected Date Range": "No se encontraron datos para el rango de fecha seleccionado",
  "No Maestro Accounts": " no se ha configurado ninguna cuenta en la base de datos Maestronet",
  "No Results Found Try Other": "No se han encontrado resultados, pruebe con una búsqueda distinta",
  "Not Assigned": "Sin asignar",
  "Not authorized user": "Usuario no autorizado",
  "Not Compare Deal": "Dejar de comparar",
  "Not Confirmed": "Su email no está confirmado. Por favor, póngase en contacto con soporte",
  "Not Recommended Browser": "Este navegador no es recomendado. Intente acceder desde otro navegador soportado (Chrome o Firefox)",
  "Not Supported Browser": "Por favor, intente acceder desde un navegador soportado (Chrome, Firefox...)",
  "Number of Agents Commissioned": "# Agentes Comisionados",
  "Number of Contracts Commissioning": "# Contratos Comisionados",
  "Number of Tickets commissioned": "# Tickets Comisionados",
  "Open": "Abierto",
  "on-gross": "En bruto",
  "Origin": "Origen",
  "Origin Data": "Origen de los datos",
  "Over Commission": "Sobrecomisión",
  "Password Reset": "Reinicio de contraseña",
  "Password Verification": "Verificar contraseña",
  "Payment Content Origin Data": "Datos del origen del contenido del pago",
  "Payment Scheduling": "Programación de pagos",
  "Payment Sending": "Envío de pagos",
  "Payment Detail": "Detalle de pago",
  "Payment Detail Of": "Detalle de pago del fichero ",
  "Payment Documents": "Documentos de pago",
  "Payment ID": "ID Pago",
  "Payments In Error": "Hay {{ amountPaymentError }} ficheros de pagos en estado ",
  "Payment Management": "Gestión de Pagos",
  "Payment Single Saved": "Va a comenzar la generación del fichero de pago con nombre: {{ param }}",
  "Payment Type": "Tipo de pago",
  "Period Bigger Select Data": "Si selecciona un período mayor de tres meses, debe seleccionar al menos un agente, grupo de agentes o contrato",
  "Period Filter": "Filtro de períodos",
  "Period from": "Período desde",
  "Period range": "Rango de períodos",
  "Period to": "Período hasta",
  "Periodic": "Periódico",
  "Point Of Sale": "Punto de venta",
  "Previous Page": "Anterior",
  "Proceed": "Proceder",
  "Products": "Productos",
  "Query": "Consulta",
  "Question Delete MaestroNet Account": "¿Está seguro de que quiere eliminar la cuenta de maestronet?",
  "Question Lock User": "¿Está seguro de que quiere desactivar al usuario?",
  "Question Send Communication": "¿Está seguro de que quiere enviar la comunicación?",
  "Question Unlock User": "¿Está seguro de que quiere activar al usuario?",
  "Rejected" : "Rechazado",
  "Remote": "Remoto",
  "Remote Description": "Descripción",
  "Remote Error UniqueKey": "Ya existe un remoto con el mismo tipo-servidor-puerto",
  "Remote For Responses": "Remoto para respuestas",
  "Remote Host": "Servidor",
  "Remote Not Found": "Ha ocurrido un problema al obtener la información del remoto",
  "Remote Port": "Puerto",
  "Remote Type": "Tipo de remoto",
  "Remote Updated": "Remoto actualizado correctamente",
  "Resolved": "Resuelto",
  "Reset Password": "Resetear contraseña",
  "Reply": "Responder",
  "Reply Communication": "Responder comunicación",
  "Response Bsplink": "Respuesta bsplink",
  "Response File": "Fic. Respuesta",
  "Resp Date": "Fecha de Resp",
  "Response Date": "Fecha de Respuesta",
  "required": "es obligatorio",
  "Required Airline": "La aerolínea es obligatoria",
  "Required App Name": "El nombre de la aplicación es obligatorio",
  "Required App Description": "La descripción de la aplicación es obligatorio",
  "Required Body": "El cuerpo del mensaje es obligatorio",
  "Required CommunicationType": "El tipo de comunicación es obligatorio",
  "Required Contact Name": "El nombre de contacto es obligatorio",
  "Required Contact Phone": "El teléfono de contacto es obligatorio",
  "Required Countries": "Los países son obligatorios",
  "Required Customer Data": "Por favor, comprueba el nombre, el alias y los campos de bases de datos",
  "Required Customer Email For ApiComm": "Se requiere email para acceder a la API Pública",
  "Required Customer Type": "Tipo de cliente requerido",
  "Required Database Server": "El servidor es obligatorio",
  "Required Database UserName": "El nombre de usuario de la base de datos es obligatorio",
  "Required Description": "La descripción es obligatoria",
  "Required Due Date When ContractRequest": "La fecha límite es obligatoria cuando el tipo es solicitud de contrato",
  "Required Field": "Campo requerido",
  "Required Host": "El servidor es obligatorio",
  "Required IataCode": "El código de aerolínea es obligatorio",
  "Required Instance": "El nombre de la instancia es obligatorio",
  "Required Instance-Port": "La instancia o el puerto deben tener valor",
  "Required Only One Field": "Solo un campo es obligatorio",
  "Required Remote": "El remoto es obligatorio",
  "Required Remote Use Type": "El tipo de remoto es obligatorio",
  "Required Subject": "El asunto es obligatorio",
  "Required To": "El 'para' es requerido",
  "Required User Directory": "El directorio de usuario es obligatorio",
  "Required Value": "Es obligatorio seleccionar un valor",
  "Return Days": "Días de regreso",
  "Role Admin Accelya": "Administrador Accelya",
  "Role Agency Accelya": "U. agencia de viajes",
  "Role Airline User": "U. normal de aerolínea",
  "Role Airline User Plus": "U. aerolínea administrador",
  "Role Esmash User": "U. Esmash",
  "Role Memo Auditor": "U. Memo auditor",
  "Role Premium User": "U. Premium",
  "Role Static Anonymous": "Anónimo",
  "Routing": "Recorrido",
  "Save Comment": "Guardar comentario",
  "Search": "Buscar",
  "Search By App Name": "Búsqueda por aplicación",
  "Search By App Login": "Búsqueda por login",
  "Search One Account": "Busque una cuenta",
  "Seconds": "Segundos",
  "See Task Detail": "Ver detalle de tarea",
  "Select Cycle Type": "Seleccionar el tipo de ciclo",
  "Select File": "Seleccionar archivo",
  "Select Month": "Seleccionar mes",
  "Select Period": "Seleccionar periodo",
  "Select Range": "Seleccionar rango",
  "Select One Airline": "Seleccionar aerolínea",
  "Select One Currency": "Seleccionar divisa",
  "Select One Country": "Seleccionar país",
  "Select One Customer": "Seleccionar cliente",
  "Select One Customer And Premium": "Seleccione un cliente y rol premium",
  "Select One Option": "Seleccionar opción",
  "Select One Role": "Seleccionar rol",
  "Selected File Is Empty": "El archivo seleccionado está vacío",
  "Selected File Not Allowed": "El tipo de archivo seleccionado no está permitido",
  "Select Year": "Selecionar año",
  "Send": "Enviar",
  "Send Communication": "Enviar Comunicación",
  "Send Time": "Fecha de envío",
  "Send To": "Enviar a",
  "Shared Remote": "Remoto compartido",
  "Single": "Único",
  "SomeComment": "Algún comentario..",
  "Start Date": "Fecha de Inicio",
  "State": "Estado",
  "Status": "Estado",
  "Subject Characters Minimum Communications": "El asunto debe tener al menos 5 caracteres",
  "Support Description": "Póngase en contacto con Net Remit Customer Support y acceda a los servicios de B.P.O",
  "Surface": "Surface",
  "Task Detail": "Detalle de la tarea",
  "Task Template Expired": "La plantilla de la tarea está expirada porque se editó y se ha creado otra posterior",
  "Task Template Updated": "La plantilla de la tarea ha sido actualizada correctamente",
  "Text Cancel": "¿Está seguro de que desea salir sin guardar los cambios?",
  "Text Cancel Payment": "¿Está seguro de que desea cancelar este pago?",
  "Text Stop Edit": "¿Está seguro de que desea dejar de editar sin guardar los cambios?",
  "Text delete": "¿Está seguro de que desea eliminar permanentemente el registro seleccionado?",
  "Text Save": "¿Quiere guardar los cambios antes de salir?",
  "Text Send Password": "¿Está seguro de que desea enviar un e-mail al usuario con un enlace para resetear su contraseña y así activar la cuenta?",
  "Time": "Tiempo",
  "To": "Para",
  "to": "para",
  "To2": "Hasta",
  "Token not valid": "El token no es válido",
  "Tools": "Herramientas",
  "Tourcodes": "Tour Code",
  "Total Amount":"Monto Total",
  "Travel Periods": "Periodos de viaje",
  "Trend Number Tickets": "Tendencia Número de Tickets",
  "Trend Overcomission": "Tendencia Sobrecomisión",
  "Type": "Tipo",
  "Unlock": "Activar",
  "Unlock User": "Activar usuario",
  "UpdateUserOk": "La información del usuario ha sido actualizada correctamente",
  "UPDATE": "CAMBIO",
  "Updating": "Actualizando..",
  "Upload To Remote": "Subir a remoto",
  "Unselect Deal": "Deseleccionar acuerdo",
  "User Directory": "Directorio de Usuario",
  "User Disabled": "Su cuenta de Net Remit ha sido deshabilitada. Por favor, póngase en contacto con soporte",
  "User Name":"Nombre de Usuario",
  "User Not Admin": "Ha ocurrido un problema inesperado. Por favor, póngase en contacto con soporte",
  "User Role": "Rol de usuario",
  "User Saved Correctly": "El usuario ha sido guardado correctamente",
  "Users": "Usuarios",
  "Users Administration": "Administración de Usuarios",
  "Verified": "Verificado",
  "Verifying": "Verificando",
  "Version": "Versión",
  "View Deal": "Ver acuerdo",
  "View Payment Detail": "Ver detalle del pago",
  "Video Tutorial": "Vídeo Tutorial",
  "Volume": "Objetivos",
  "Warning Communication Modal Info": "¿Está seguro de que quiere cerrar esta comunicación? \nUna vez la comunicación se cierre, no podrá volver a abrirla",
  "Warning Communication Modal Title": "Advertencia: se va a cerrar esta comunicación",
  "web": "Web login",
  "Weeks": "semanas",
  "Welcome": "Bienvenido a",
  "Will Be Displayed After Saving": "Se mostrará después de guardar",
  "Write New Comment": "Escriba un nuevo comentario",
  "Yes": "Sí",
  "Zip": "Código postal",
  "% Over Commission": "% Sobrecomisión",

  "Y": "S",
  "N": "N",

  "Sunday": "Domingo",
  "Monday": "Lunes",
  "Tuesday": "Martes",
  "Wednesday": "Miércoles",
  "Thursday": "Jueves",
  "Friday": "Viernes",
  "Saturday": "Sábado",

  "Day-Of-Week Values Must Be Between 1 And 7": "Los valores del día de la semana deben estar entre 1 y 7",
  "Support For Specifying Both A Day-Of-Week AND A Day-Of-Month Parameter Is Not Implemented": "Debe especificarse un día de la semana o tener el valor '?' si el día del mes tiene valor",
  "Month Values Must Be Between 1 And 12": "Los valores del mes deben estar entre 1 y 12",
  "Day Of Month Values Must Be Between 1 And 31": "Los valores del día del mes deben estar entre 1 y 31",
  "Hour Values Must Be Between 0 And 23": "Los valores de hora deben estar entre 0 y 23",
  "Minute And Second Values Must Be Between 0 And 59": "Los valores de minuto y segundo deben estar entre 0 y 59",
  "Error Next Execution Date": "Error al calcular la siguiente fecha de ejecución",
  "Illegal Characters For Seconds": "Caracteres ilegales para los segundos",
  "Illegal Characters For Minutes": "Caracteres ilegales para los minutos",
  "Illegal Characters For Hour": "Caracteres ilegales para la hora",
  "Illegal Characters For Day Month": "Caracteres ilegales para el día del mes",
  "Invalid Month Value": "Valor de mes no válido",
  "Invalid Day-Of-Week Value": "Valor de día de la semana no válido",
  "The Next Execution Will Be Within Few Seconds": "La siguiente ejecución será en unos segundos",
  "The Next Execution Will Be On": "La siguiente ejecución será {{ param }}",
  "There Will Be No Next Execution": "No habrá siguiente ejecución porque el pago periódico ha sido deshabilitado",
  "'?' Can Only Be Specified For Day-Of-Month -OR- Day-Of-Week": "'?' solo se puede especificar para el día del mes o el día de la semana",
  "Administration": {
    "Cleanup": {
      "Errors": {
        "Error Saving Data": "Ha ocurrido un error al guardar la información de la limpieza de datos",
        "Error Updating Process Activation": "Ha ocurrido un error al actualizar la activación del proceso de limpieza",
        "Error Updating Process Deactivation": "Ha ocurrido un error al actualizar la desactivación del proceso de limpieza"
      },
      "Form": {
        "Day Of The Month": "Día del mes (1 a 28)",
        "Day Of The Week": "Día de la semana",
        "Errors": {
          "Day Of The Month Required": "Día de mes es obligatorio",
          "Day Of The Week Required": "Día de la semana es obligatorio",
          "Retention Months Required": "Los meses de retención son obligatorios",
          "Time Required": "La hora es obligatoria"
        },
        "Retention Months": "Meses de retención (1 a 99)",
        "Select A Day Of The Week": "Seleccione día semana",
        "Time Execution": "Hora"
      },
      "Information": {
        "Enabled When Filled Form": "Opción habilitada cuando se indique el tiempo de ejecución de la limpieza",
        "Process Disabled": "El proceso ha sido desactivado correctamente",
        "Process Enabled": "El proceso ha sido activado correctamente",
        "Saved Successfully": "La información de la limpieza de datos se ha guardado correctamente"
      },
      "Last Execution": "Última ejecución",
      "No Execution Date": "No hay ejecución previa",
      "Process Disabled": "Proceso inhabilitado",
      "Process Enabled": "Proceso habilitado",
      "Status": {
        "Error": "Error",
        "Launched": "En marcha",
        "Success": "Acabado correctamente",
        "Working": "En proceso"
      },
      "Title": "Gestión de limpieza de datos",
      "Warning": {
        "Months Retained Detail": "Los Meses de Retención para este cliente son: {{ months }}, y el intervalo del periodo seleccionado se solapa con los meses retenidos.",
        "Months Retained Title": "¿Está seguro de que desea continuar con esta acción? ",
        "Months Retained Unknown": "Los Meses de Retención para este cliente son desconocidos y el rango de periodos seleccionado puede solapar los meses retenidos."
      }
    },
    "Customers":{
      "AllowedIP": "IP permitida",
      "Country Code List": "Lista de códigos de país",
      "Country Codes": "Códigos de país",
      "Customer API": "API de Cliente",
      "Customer API Access": "Administrador de Claves API",
      "Customer Type": "Tipo de cliente",
      "Database" : "Bases de datos",
      "Database Host": "Host",
      "Database Name": "Nombre de BD",
      "Database Params": "Parámetros",
      "Database Password": "Contraseña de BD",
      "Database Port": "Puerto",
      "Database Server": "Servidor",
      "Database User Name": "Usuario de BD",
      "Description Shown After Saved": "Disponible después de guardar",
      "Errors": {
        "Airline Already Exists To This Customer": "La aerolínea introducida ya está asociada a este cliente",
        "Allowed IP Already Exists": "IP añadida anteriormente",
        "Country Codes Not Duplicated": "Los códigos de país no pueden estar repetidos",
        "Error Saving New Customer": "Error al guardar nuevo cliente",
        "Error Updating Customer": "Error al actualizar cliente",
        "Incorrect Airline Format": "El formato de la aerolínea debe tener 3 dígitos",
        "Incorrect Allowed IP": "Formato de IP incorrecto. Ejemplo 120.0.0.1",
        "Incorrect Country Format": "Los países de 2 caracteres y separados por coma. Ejemplo XX,XX,XX",
        "Incorrect Database Host": "Formato de host de base de datos incorrecto",
        "Incorrect Database Name": "Formato de nombre de base de datos incorrecto",
        "Incorrect Database Params": "Formato de parámetros incorrecto",
        "Incorrect Database Server": "Formato de nombre de base de datos incorrecto",
        "Must Be One Database Per Product": "Nombre de base de datos requerido",
        "Required Database Name": "Nombre de base de datos requerido",
        "Required Host": "Host requerido",
        "Required Params": "Parámetros requeridos",
        "Required Server": "Servidor requerido"
      },
      "General" : "General",
      "Markets" : "Mercados",
      "Partnership" : "Asociación",
      "Products" : "Productos",
      "Save Customer Ok": "El cliente ha sido guardado correctamente",
      "Travel Agent": "Agencia de viajes",
      "Update Customer Ok": "El cliente ha sido actualizado correctamente",
      "Warnings": {
        "No Selected Partners": "No hay partners seleccionados"
      }
    },
    "Data Cleanup Log": {
      "Title": "Historial de Limpieza de Datos"
    },
    "Manual Cleanup": {
      "Title": "Gestión de limpieza manual de datos"
    },
    "Title": "Administración",
    "Users": {
      "Airline Plus Airline Can Not Be Selected Together": "Usuario aerolínea administrador y aerolínea no pueden seleccionarse juntos",
      "Premium MemoAudit Can Not Be Selected No Airline": "Premium y memo auditor no pueden seleccionarse sin rol aerolínea"
    }
  },
  "Change Pass": {
    "Change Password Email Sent": "Se ha enviado un correo a su dirección para confirmar su cambio de contraseña",
    "Current Password": "Contraseña actual",
    "Done Redirecting": "Hecho, redirigiendo...",
    "Errors": {
      "Current Password Required": "La contraseña actual es obligatoria",
      "Length Maximum Password": "El tamaño maximo para la contraseña son {{ quantityMax }} caracteres",
      "Length Minimum Password": "El tamaño mínimo para la contraseña son {{ quantityMin }} caracteres",
      "Required Current Password": "La contraseña actual es obligatoria"
    },
    "New Password": "Nueva contraseña",
    "New Password2": "Repita la nueva contraseña"
  },
  "Common": {
    "Accept": "Aceptar",
    "Actions": "Acciones",
    "Add": "Añadir",
    "Airline": "Aerolínea",
    "AirlineCode": "Código de aerolínea ",
    "Airlines": "Aerolíneas",
    "Back": "Atrás",
    "Cancel": "Cancelar",
    "Change My Password": "Cambiar Contraseña",
    "Choose One Contract": "Seleccione un contrato",
    "Clear": "Limpiar",
    "Code": "Código",
    "Contract Code": "Código de acuerdo",
    "Countries": "Países",
    "Country": "País",
    "Creation Date": "Fecha de Creación",
    "Creation Date Minus Short": "Fecha creación",
    "Currency": "Moneda",
    "Customer": "Cliente",
    "Customer Reference": "Referencia de cliente",
    "Customers": "Clientes",
    "Cycle":"Ciclo",
    "Database Type": "Tipo base de datos",
    "Date": "Fecha",
    "Delete": "Eliminar",
    "Description": "Descripción",
    "Disable": "Inhabilitar",
    "Disabled": "Inhabilitado",
    "Document Type": "Tipo Contenido",
    "Edit": "Editar",
    "Email": "Email",
    "Enable": "Habilitar",
    "Enabled": "Habilitado",
    "Errors": {
      "Required Airline": "La aerolínea es obligatoria"
    },
    "Execute": "Ejecutar",
    "Execute Now": "Ejecutar ahora",
    "Execute Time": "Hora ejecución",
    "ExpireDate": "Fecha de expiración",
    "Filter By": "Filtrar por",
    "Frequency": "Frecuencia",
    "From": "Desde",
    "from": "desde",
    "From Date": "Fecha desde",
    "Last Name": "Apellidos",
    "Last Update": "Última actualización",
    "Month": "Mes",
    "Name":"Nombre",
    "No Data To Show": "No hay datos para mostrar",
    "No Results Found": "No se han encontrado resultados con su búsqueda",
    "Password": "Contraseña",
    "Period": "Periodo",
    "Period From": "Periodo desde",
    "Period To": "Periodo hasta",
    "Required Frequency Choice": "Es obligatorio elegir una opción para el pago",
    "Save": "Guardar",
    "Select One Airline": "Seleccione una aerolínea",
    "Select One Country": "Seleccione un país",
    "Select One Customer": "Seleccione un cliente",
    "Send": "Enviar",
    "ShortName": "Alias",
    "Show": "Mostrar",
    "Status": "Estado",
    "To": "Para",
    "To Date": "Fecha hasta",
    "ToDate": "Hasta",
    "User": "Usuario",
    "Username": "Usuario / Correo",
    "View Details": "Ver detalles",
    "Warning": "¡Aviso!"
  },
  "Communications": {
    "Assigned": "Asignado/a",
    "Body Message": "Cuerpo del mensaje",
    "Cc": "Cc",
    "Communication Identifier": "Identificador de comunicación",
    "Communication Type": "Tipo de comunicación",
    "Communication Types": "Tipos de comunicación",
    "Created by": "Creado por",
    "Errors": {
      "Updating Communication": "Error al actualizar la comunicación. Por favor, revise los datos"
    },
    "New Communication": "Nueva comunicación",
    "subject": "asunto",
    "Subject": "Asunto",
    "To Me": "A mí"
  },
  "Cron Expressions": {
    "Seconds Option Not Compatible": "No se puede asignar ejecuciones cada segundo"
  },
  "Cycle":{
    "Bimonthly":{
      "Item": "{{#}} período de dos meses",
      "Title": "Bimensual"
    },
    "Quadrimester":{
      "Item": "{{#}} cuatrimestre",
      "Title": "Cuatrimestre"
    },
    "Quarter":{
      "Item": "{{#}} trimestre",
      "Title": "Trimestre"
    },
    "Semester":{
      "Item": "{{#}} semestre",
      "Title": "Semestre"
    },
    "Year":{
      "Item": "Todo el año",
      "Title": "Año"
    }
  },
  "Deals":{
    "Absolute Value": "Valor absoluto",
    "Achievement": "Alcanzar objetivo",
    "Add Tier": "Añadir tier",
    "Agreement Code": "Código del acuerdo",
    "Agreement Name": "Nombre del acuerdo",
    "Associated": "Acuerdos asociados",
    "Associated Agreements Updated": "Se han actualizado los acuerdos stand alone asociados al acuerdo de objetivos",
    "Available": "Acuerdos disponibles",
    "Back To Base": "Volver a la base",
    "Both": "Ambos",
    "Calculation Base": "Cálculo base",
    "Calculation Type": "Tipo de cálculo",
    "Deal Name": "Nombre de acuerdo",
    "Deal Scope": "Ámbito de acuerdo",
    "Deleted Ok":"El contrato de objetivos con nombre {{param}} se ha borrado correctamente",
    "Discount Upfront":"Descuento Upfront",
    "Domestic":"Doméstico",
    "Ending Date": "Fecha fin",
    "Errors": {
      "Getting Associated Contracts": "Error al recuperar los acuerdos asociados",
      "Incorrect Deal Name Format": "El formato del nombre del acuerdo no es correcto",
      "Incorrect Maximum Target Per Agent Format": "El formato de objetivo máximo por agente no es correcto",
      "Incorrect Maximum Target Per Deal Format": "El formato de objetivo máximo por acuerdo no es correcto",
      "Length Minimum Deal Name": "El tamaño mínimo para el nombre del acuerdo son {{ quantityMin }} caracteres",
      "Required Calculation Base": "El cáculo base es obligatorio",
      "Required Calculation Type": "El tipo de cálculo es obligatorio",
      "Required Deal Name": "El nombre de acuerdo es obligatorio",
      "Required Minimum Value": "El valor mínimo es obligatorio",
      "Required One Tier": "Al menos un tier es obligatorio",
      "Required Payment Currency": "La moneda de pago es obligatoria",
      "Required Payment Type": "El modo de pago es obligatorio",
      "Required Payment Value": "El valor de pago es obligatorio",
      "Required Target Per Agent": "Objetivo máximo por agente es obligatorio",
      "Required Target Per Deal": "Objetivo máximo por acuerdo es obligatorio",
      "Required Tier Value": "El valor del tier es obligatorio",
      "Required Time Reference": "El tiempo de referencia es obligatorio",
      "Saving New ThresholdContract": "Error al guardar un nuevo contrato de objetivos",
      "Tier Already Exists": "Este valor mínimo ya existe",
      "Updating Associated Contracts": "Error al actualizar los contratos asociados",
      "Updating ThresholdContract": "Error al actualizar un contrato de objetivos"
    },
    "Gross": "Bruto",
    "Gross Value": "Valor bruto",
    "Growth": "Crecimiento",
    "International": "Internacional",
    "Last Month": "Último mes",
    "Last Period": "Último periodo",
    "Manage Agreements": "Gestionar acuerdos",
    "Manage Stand Alone Deals": "Gestionar los acuerdos stand alone asociados al acuerdo de objetivos",
    "Minimum Value": "Valor mínimo",
    "Month": "Mes",
    "Net": "Neto",
    "Net Value": "Valor neto",
    "New Threshold Deal": "Nuevo acuerdo de objetivos",
    "No StandAlone Deals": "Este acuerdo de objetivos no tiene stand alone asociados ni existe ninguno disponible para asociarlo",
    "Number Documents": "Número de documentos",
    "Payment Currency": "Moneda de pago",
    "Payment Type": "Modo de pago",
    "Payment Value": "Valor de pago",
    "Percentage": "Porcentaje",
    "Period": "Periodo",
    "Report Status": {
      "Created": "Creado",
      "Error": "Error",
      "Error Exchange": "Error de conversión",
      "Ongoing": "En curso",
      "Pending": "Pendiente"
    },
    "Same Last Month": "Mismo mes anterior",
    "Same Last Period": "Mismo periodo anterior",
    "Same Month Last Year": "Mismo mes de año anterior",
    "Same Period Last Year": "Mismo periodo de año anterior",
    "Search By Agreement Name": "Busca por nombre de acuerdo",
    "Starting Date": "Fecha inicio",
    "Target Per Agent": "Objetivo por agente",
    "Target Per Deal": "Objetivo por acuerdo",
    "Text Cancel Create New Threshold Deal": "¿Está seguro de que desea cancelar la creación del acuerdo de objetivos sin guardarlo?",
    "Text Delete Threshold Deal": "¿Está seguro que desea borrar este acuerdo de objetivos?",
    "Text Delete Threshold Report": "¿Está seguro que desea borrar este informe de objetivos?",
    "Text Reset Page Threshold Deal": "¿Está seguro que desea iniciar un nuevo acuerdo de objetivos sin guardar los cambios?",
    "Threshold Contract Created": "El nuevo acuerdo para {{airline}} en {{country}} ha sido creado correctamente",
    "Threshold Contract Updated": "El acuerdo para {{airline}} en {{country}} ha sido actualizado correctamente",
    "Threshold Time Reference": {
      "M": {
        "L": "Último mes",
        "SLM": "Mismo periodo último mes",
        "SLY": "Mismo periodo último año"
      },
      "P": {
        "L": "Último periodo",
        "SLM": "Mismo periodo último mes",
        "SLY": "Mismo mes último año"
      }
    },
    "Tier": "Tier",
    "Tier Value": "Valor del tier",
    "Time Reference": "Tiempo de referencia",
    "Update Threshold Deal": "Actualizar acuerdo de objetivos"
  },
  "ETL Executions": {
    "All Airlines": "Todas",
    "End Time": "Fecha fin",
    "Errors": {
      "Incorrect Airport Format": "Formato de aeropuerto incorrecto",
      "When Removing": "Error al intentar borrar la ejecución"
    },
    "Error Finding": "No se encontraton ejecuciones de ETL",
    "Execution Dates": "Fechas de ejecución",
    "Execution Parameters": "Parámetros de ejecución",
    "Execution Report": "Detalle de la ejecución",
    "Extraction Range": "Rango de extracción",
    "Label": {
      "D": "E",
      "R": "R"
    },
    "Launch Time": "Fecha ejecución",
    "Removed Successfully": "Ejecución ETL borrada correctamente",
    "Relaunched Successfully": "Ejecución ETL relanzada correctamente",
    "Start Time": "Fecha inicio",
    "Tooltip": {
      "Delete": "Borrar",
      "Relaunch": "Ejecución Marcada para su Relanzamiento",
      "Retry": "Reintentar proceso",
      "ToDelete": "Ejecución Marcada para su Eliminación"
    },
    "Warning" : {
      "Delete Message" : "Está a punto de eliminar la ejecución DataByCountryId: {{dataByCountryId}}, esta acción no puede ser revertida.",
      "Delete Message All" : "Está a punto de eliminar las ejecuciones pendientes y en error, esta acción no puede ser revertida.",
      "Relaunch Message" : "Se procederá al relanzamiento de la ejecución DataByCountryId: {{dataByCountryId}}.",
      "Relaunch Message All" : "Se procederá al relanzamiento de las ejecuciones pendientes y en error.",
      "Title" : "Atención: ¿Está seguro de que desea continuar?"
    }
  },
  "ETL Management": {
    "Configure ETL Extraction": "Configurar extracción",
    "Execution Failed": "No se ha podido guardar ninguna ejecución",
    "Execution Pending": "No se ha podido guardar ninguna ejecución porque todavía hay ejecuciones pendientes para el mismo país y cliente",
    "Execution Saved": "La solicitud de extracción de la etl de maestro se ha añadido a la cola"
  },
  "Generic Errors": {
    "Error Exchange": "Error al obtener el cambio de divisas en las fechas seleccionadas.",
    "Error Generic Onload": "Se ha producido un error al cargar los datos de la página. Por favor, póngase en contacto con soporte",
    "Error Generic Onload For Support": "Se ha producido un error al cargar los datos de la página. Por favor hecha un vistazo a los ficheros de log.",
    "Error Logout": "Se ha producido un error al realizar el cierre de sesión. Por favor hecha un vistazo a los ficheros de log.",
    "Existing Email": "El email que intenta guardar ya está asociado a otro usuario",
    "File Not Found": "El fichero que intenta descargar no se encuentra disponible",
    "Greater Period From": "Periodo desde es mayor que periodo hasta",
    "Incorrect Customer Name": "El formato del nombre del cliente no es correcto",
    "Incorrect Email Format": "Formato de email incorrecto",
    "Incorrect Numeric Format": "Solo admite números",
    "Incorrect Period From": "El formato de periodo desde no es correcto",
    "Incorrect Period To": "El formato de periodo hasta no es correcto",
    "Incorrect Tier Format": "Formato de tier incorrecto",
    "Length Maximum Airline": "El tamaño máximo para la aerolínea son {{ quantityMax }} caracteres",
    "Length Minimum Name": "El tamaño mínimo son {{ quantityMax }} caracteres",
    "Length Minimum Period": "El tamaño mínimo del periodo son 7 caracteres",
    "Name Not Unique": "El nombre que intenta guardar ya está asociado a otro cliente",
    "Period To Bigger": "Periodo hasta debe ser mayor que periodo desde",
    "Required Countries": "Los países son obligatorios",
    "Required Country": "El pais es obligatorio",
    "Required Credential": "La credencial es obligatoria",
    "Required Currency": "La moneda es obligatoria",
    "Required Customer": "El cliente es obligatorio",
    "Required Date From": "Fecha desde es obligatoria",
    "Required Email": "El email es obligatorio",
    "Required Login": "El usuario es obligatorio",
    "Required Name": "Nombre requerido",
    "Required Password": "La contraseña es obligatoria",
    "Required Password Verification": "La contraseña de verificación es obligatoria",
    "Required Period From": "Periodo desde obligatorio",
    "Required Period To": "Periodo hasta obligatorio",
    "Required Port": "El puerto es obligatorio",
    "Required Retention Months": "Los meses de retención deben estar entre 0 y 99",
    "Required Role": "El rol es requerido",
    "Required ShortName": "El alias es requerido",
    "Required User Name": "El nombre de usuario es obligatorio",
    "ShortName Not Unique": "El alias que intenta guardar ya está asociado a otro cliente",
    "ShortName Pattern": "El formato de alias no es correcto"
  },
  "Generic Warnings": {
    "No Data By Country" : "No se han obtenido resultados para el país seleccionado.",
    "No Data To Show": "No hay datos para mostrar",
    "Warning": "Aviso"
  },
  "Login": {
    "Contact Us": "Contáctanos",
    "Enter Credentials": "Por favor, escriba sus credenciales",
    "Enter MFA Code": "Introduzca el código desde su aplicación de autenticación MFA",
    "Errors": {
      "Enter Username": "Por favor, escriba su nombre de usuario",
      "Invalid MFA Code": "Por favor, inserte un código de 6 dígitos",
      "Invalid MFA Code Attempts": "Código MFA inválido. Intentos restantes: {{ attemptsRemaining }}",
      "Invalid MFA Code No Attempts": "Código MFA inválido",
      "Locked": "El usuario ha sido bloqueado por exceso de intentos fallidos. Por favor, vuelva a intentarlo en {{ lockEndMinutes }} minutos",
      "Login Error": "Se ha producido un error durante el inicio de sesión. Por favor, póngase en contacto con soporte",
      "User Incorrect": "Usuario/contraseña incorrectos",
      "User Password Incorrect": "Usuario/contraseña incorrectos. Intentos restantes: {{ attemptsRemaining }}"
    },
    "Forgot Password": "Olvidé mi contraseña",
    "Information": {
      "Change Language": "Cambia idioma",
      "Microsoft Info": "Información sobre Microsoft Authenticator"
    },
    "Log In": "Iniciar sesión",
    "Login Pattern": "El formato del login no es correcto",
    "MFA": {
      "After Steps": "Después de completar los pasos, la aplicación mostrará un código de seis dígitos para usar en el inicio de sesión",
      "Back": "Volver al login",
      "Code": "Código",
      "Create Account": "En la aplicación, cree una cuenta de tipo 'Trabajo o Escuela'",
      "Enter Code": "Si no puede escanearlo, ingrese el siguiente código manualmente",
      "Information": "Recomendamos utilizar Microsoft Authenticator u otras aplicaciones similares como software de autenticación multifactor (MFA) de GNR5. Siga estos pasos a continuación para configurarlo:",
      "Install": "Instálelo en su dispositivo móvil",
      "QR Information": "para obtener más información sobre la aplicación y descargas para dispositivos iOs y Android",
      "QR Link": "Visite el sitio web del autenticador de Microsoft",
      "Scan": "Escanee el código QR que se muestra con la app Microsoft Authenticator, una vez que se identifique en la página de inicio de sesión",
      "URL": "URL"
    },
    "Password Updated Correctly": "Contraseña actualizada correctamente",
    "Passwords Must Match": "Las contraseñas deben coincidir",
    "Recovery Email Sent": "Si es un usuario válido, recibirá un correo con un enlace a una página donde podrá redefinir su contraseña",
    "Verify": "Verificar"
  },
  "MemoPayments": {
    "accepted" : "Aceptado",
    "accepted-Complete": "Aceptado",
    "Additional Data": "Datos adicionales",
    "Cancel Payment" : "Cancelar pago",
    "cancelled" : "Cancelado",
    "cancelled-Complete": "Cancelado",
    "connection-rejected" : "Conexión rechazada",
    "connection-rejected-Complete": "Conexión rechazada (¿usuario/pass incorrectos?)",
    "connection-timed-out" : "Timeout",
    "connection-timed-out-Complete": "Tiempo de conexión agotado",
    "Contact Info": "Información de contacto",
    "Content Origin": "Origen del contenido",
    "Content Type": "Tipo de contenido",
    "Created Payments": "Pagos creados",
    "Customer Details": "Detalles de cliente",
    "Download Report": "Descargar informe",
    "Empty File": "Fichero vacío",
    "Enable Task": "Activar esta tarea",
    "Enter Memo Content": "Introduzca un memo content válido",
    "Error Getting Sequence": "Se ha producido un error al obtener los datos de la secuencia y no podrá realizar la creación del pago. Por favor, póngase en contacto con soporte",
    "Error Memo Payment Duplicated": "No se puede grabar el pago porque ya existe uno en la base de datos con el mismo país, aerolínea y algoritmo",
    "Error Memo Payment With Documents Used": "No se puede grabar el pago porque ya existe un pago con alguno de esos documentos usados",
    "Error Memo Payment Period Pending Audit": "El periodo ya ha sido inclcuido en otro pago, por favor cancele el pago para continuar",
    "Error Memo Payment Period Sent": "El periodo ya ha sido incluido en otro pago",
    "Error Reprocessing Payment": "Un error ha ocurrido al reprocesar el pago. Por favor, póngase en contacto con soporte",
    "Error Saving Memo Payment": "Se ha producido un error al guardar el nuevo pago",
    "error-creating-file" : "Error crear fichero",
    "error-creating-file-Complete": "Error al crear/enviar el fichero de pago",
    "error-extracting-data" : "Error extrayendo datos",
    "error-extracting-data-Complete" : "Error extrayendo los datos del fichero",
    "Extraction End Date": "Fin extracción",
    "Extraction Start Date": "Inicio extracción",
    "FileSequence Already Exists": "La secuencia ya existe",
    "From Doc": "Memo Doc. inicial",
    "From Document": "Documento Inicial",
    "From Document ACM": "Ini. ACM",
    "From Document ADM": "Ini. ADM",
    "Hide Disabled Tasks": "Ocultar tareas deshabilitadas",
    "Incentive Amount": "Importe incentivo",
    "Incorrect Extraction End Date": "Fin de extracción debe ser superior a inicio de extracción.",
    "Incorrect Extraction End Date Today": "Fin de extracción debe ser superior o igual a hoy.",
    "Incorrect Format": "Formato incorrecto",
    "Incorrect Memo Content Format": "El formato correcto es: agente;Importe(no cero);Moneda (ISO) decimales;doc relacionado (opcional, no cero) 1234567;10.23;EUR2;1234567890",
    "Incorrect Numeric Higher0 Format": "Solamente admite carácteres numéricos superiores a cero",
    "Incorrect Payment Type US": "Siendo EEUU el país seleccionado, solo es válido el tipo comisión",
    "Incorrect RMIC US": "Siendo EEUU el país seleccionado, el RMIC debe estar vacío",
    "Incorrect To Document": "El documento final debe ser superior o igual al documento inicial",
    "Incorrect Vat Fare": "Con tarifa, el VAT debe estar vacío",
    "Incorrect Vat Format": "Formato VAT incorrecto",
    "Incorrect Vat US": "Siendo EEUU el país seleccionado, el VAT debe estar vacío",
    "Invalid Memostatus": "Nuevo estado incorrecto. El estado debe ser cancelado o enviado para poder actualizarse",
    "Length Maximum ReasonMemo": "El tamaño máximo de la razón del memo son {{ quantityMax }} caracteres",
    "List Memo Docs": "Lista de documentos memo",
    "List Related Docs": "Lista de documentos relacionados",
    "Max & Minimum Value File Sequence": "El rango debe ser desde {{ minFileSequence }} hasta {{ maxFileSequence }} (ambos incluidos)",
    "Max Related": "Máx Relac.",
    "Memo Content": "Contenido del memo",
    "Memo Content Origin" : "Origen contenido memo",
    "Memo Document": "Documento memo",
    "Method Not Allowed": "Estado previo incorrecto. El memopayment debe encontrarse en cancelado o preparado para poder actualizarse",
    "New Payment": "Nuevo Fichero de Pagos",
    "Next Document": "Próximo documento",
    "No Database Found": "Lo sentimos, no existe una base de datos configurada para el cliente seleccionado",
    "No Payment Detail": "Lo sentimos, no existe todavía detalle del pago para mostrar",
    "No Payments": "Lo sentimos, no existen todavía pagos para mostrar",
    "no-data-found": "Datos no encontrados",
    "no-data-found-Complete": "Datos no encontrados",
    "Only prepared and pending status can be cancelled": "Solo se puede cancelar un memo con estado 'Preparado' o 'Pendiente'",
    "Only prepared status can be sent": "Solo un memo en estado 'Preparado' puede ser enviado",
    "outdated-agent-headers": "Agentes cabecera desactualizados",
    "outdated-agent-headers-Complete": "Agentes cabecera desactualizados",
    "partial-reject" : "Rechazo parcial",
    "partial-reject-Complete": "Rechazo parcial",
    "Payee-Payer Agent": "Agente beneficiario",
    "Payment Content Origin Data": "Datos del origen del contenido del pago",
    "Payment Detail": "Detalle de pago",
    "Payment Detail Of": "Detalle de pago del fichero ",
    "Payment Management": "Gestión de Pagos",
    "Payment Scheduling": "Programación de pagos",
    "Payment Sending": "Envío de pagos",
    "Payment Single Saved": "Va a comenzar la generación del fichero de pago con nombre: {{ param }}",
    "Payment Type": "Tipo de pago",
    "Payments In Error": "Hay {{ amountPaymentError }} ficheros de pagos en estado ",
    "pending" : "Pendiente",
    "pending-audit" : "Pendiente auditar",
    "pending-audit-Complete": "Pendiente auditar",
    "pending-Complete": "Pendiente (esperando la creación del fichero)",
    "prepared" : "Preparado",
    "prepared-Complete": "Preparado (archivo creado)",
    "Programmed Payments": "Pagos programados",
    "Ranges": "Rangos",
    "Reason For Memo": "Razon de emisión",
    "Reject Payment" : "Rechazar pago",
    "Related Document": "Documento relacionado",
    "Reprocess Payment": "Reprocesar pago",
    "Request Airline Auditory": "Auditoría de aerolínea",
    "Required Content Type": "El tipo de contenido es obligatorio",
    "Required Document Type": "El tipo de documento es obligatorio",
    "Required From Document": "El documento inicial es obligatorio",
    "Required MaxRelated": "El campo max.relacionados es obligatorio",
    "Required Memo Content Origin Choice": "El contenido de origen del memo es obligatorio",
    "Required Payment Documents": "Los documentos de pago son obligatorios",
    "Required PaymentType": "El tipo de pago es requerido",
    "Required Sequence": "La secuencia es obligatoria",
    "Required To Document": "El documento final es obligatorio",
    "Required Upload To Remote": "El servidor de subida es obligatorio",
    "Select": "Seleccionar",
    "Send Attachment": "Enviar adjuntos",
    "Send BspLink": "Enviar a BspLink",
    "Send To Remote": "Enviar a un servidor remoto",
    "sending" : "Enviando",
    "Sending BspLink": "Enviando a BspLink",
    "sending-Complete": "Envío por sftp",
    "sent" : "Enviado",
    "sent-Complete": "Enviado a Bsplink",
    "Sequence": "Secuencia",
    "Show Disabled Tasks": "Mostrar tareas deshabilitadas",
    "Text Reset Page Memo": "¿Está seguro de que desea iniciar un nuevo memo sin guardar los cambios?",
    "Text Reset Page Memo Frequency": "Se van a reiniciar los datos referidos a la frecuencia del pago, ¿está seguro de que desea cambiar de frequencia?",
    "To Doc": "Memo Doc. final",
    "To Document": "Documento final",
    "To Document ACM": "Fin ACM",
    "To Document ADM": "Fin ADM",
    "Total Amounts": "Cantidades totales",
    "total-reject" : "Rechazado",
    "total-reject-Complete": "Rechazo total",
    "Type Content": "Tipo y contenido",
    "unable-to-connect" : "No conexión",
    "unable-to-connect-Complete": "No puede conectarse (¿mala configuración?)",
    "unexpected-error": "Error",
    "unexpected-error-Complete": "Error inesperado",
    "View Memos List": "Ver lista de memos",
    "Warning Change Frequency": "Si se modifica la frecuencia, se perderán los datos introducidos previamente.",
    "Warning Report Not Created": "* No se puede descargar el informe porque aún no se ha generado.",
    "Warning XML Not Created": "* No se puede mostrar la lista de memos porque aún no se han generado."
  },
  "Menu Help": {
    "Analytics": "Analytics",
    "Change My Password": "Cambiar Contraseña",
    "Contract Management": "Administración Contratos",
    "CRM": "CRM",
    "Download Doc": "Descarga Documentación",
    "KPI Dashboard": "Panel Control",
    "Profile": "Perfil",
    "Release Notes": "Notas de versión",
    "Reports": "Informes",
    "Tutorial Index": "Índice Tutorial",
    "Video Tutorial": "Vídeo Tutorial"
  },
  "Menus": {
    "Administration": {
      "DataCleanUp": "Limpieza de datos",
      "DataCleanupLog": "Histórico de limpieza de datos",
      "DataManagement": "Gestión de datos",
      "IPM ETL Manager": "Gestor ETL de IPM",
      "Manual Data CleanUp": "Limpieza manual de datos",
      "New Execution": "Nueva Ejecución ETL",
      "Welcome Message": "Mensaje de Bienvenida"
    },
    "Contract Management":{
      "Backend Contracts": "Contratos de Back-end",
      "Contract Management": "Administración Contratos",
      "ETL Management": "Administración ETL",
      "Frontend Contracts":{
        "Change Market": "Cambiar Mercado",
        "Deals": {
          "Additional Conditions": "Condiciones Adicionales",
          "Copy": "Copiar",
          "Copy Deal": "Contrato",
          "Copy of Multicountry And Multiairline Deals": "Multipaís y Multiaerolíneas",
          "Copy Version": "Versión",
          "Create": "Nuevo",
          "Create Deal": "Contrato",
          "Create Deal From Other": "Copiar desde otro",
          "Create Version": "Versión",
          "Deals": "Contratos",
          "Delete": "Eliminar",
          "Mixed Conditions": "Condiciones Mixtas",
          "Modify": "Modificar",
          "Modify Deal": "Contrato",
          "Priorities": "Prioridades"
        },
        "Frontend Contracts": "Contratos de Front-end",
        "List of Contracts": "Lista de Contratos",
        "Maintenance": {
          "Application of Incentives": "Aplicación de incentivos",
          "Basic Parameters": "Parámetros básicos",
          "Carrier Segments": "Carrier de los cupones",
          "Carriers": "Aerolíneas",
          "Generic Cities": "Ciudades genéricas",
          "Group of Tour Codes": "Tour Codes",
          "Groups": "Grupos",
          "Groups of Agents": "Agentes",
          "Groups of Cities": "Ciudades",
          "Groups of Groups of Agents": "Grupos de agentes",
          "Load file with group of agents": "Grupos de agentes",
          "Load file with group of cities": "Grupo de ciudades",
          "Load file with group of tour codes": "Grupos de Tour Codes",
          "Load Group File": "Cargar Grupo | Archivo",
          "Maintenance": "Mantenimiento",
          "Parameters": "Parámetros",
          "Season Dates": "Fechas de temporada",
          "Tour Code": "Códigos de tour code"
        },
        "Master Tables": {
          "Agents": "Agentes",
          "Airports": "Aeropuertos",
          "Carriers": "Carriers",
          "Groups of Agents": "Grupos de Agentes",
          "Master Tables": "Tablas Maestras"
        },
        "Queries": {
          "Active Deals": "Activos",
          "Agent in Groups": "Agente en grupos",
          "Cities in Groups": "Ciudades en grupos",
          "Condition": "Búsqueda por condicionantes",
          "Deactivated Deals": "Desactivados",
          "Deals": "Contratos",
          "Expired Deals": "Caducados",
          "FAC simile": "FAC-simile",
          "Groups": "Grupos",
          "Groups of Agents":"Agentes",
          "Groups of Cities": "Ciudades",
          "Groups of Groups": "Grupos de agentes",
          "Mismatch Condition Agreement": "Mismatch",
          "Queries": "Consultas",
          "Settled": "Facturados",
          "Tickets": "Tickets"
        },
        "Select Account": "Seleccionar Mercado"
      },
      "Threshold Contracts Management": "Contratos de objetivos"
    },
    "Logout": "Cerrar sesión",
    "Profile": "Perfil"
  },
  "MFA": {
    "Values": {
      "Mobile": "Autenticador móvil",
      "None": "Ninguno"
    }
  },
  "Mixed Conditions": {
    "Airport From": "Aeropuerto desde",
    "Airport To": "Aeropuerto hasta",
    "Blackout Dates": "FECHAS RESTRINGIDAS",
    "Carrier": "Carrier",
    "Carrier Class": "AEROLÍNEA + CLASE",
    "Carrier Flight Number": "AEROLÍNEA + NÚMERO DE VUELO",
    "Class": "Clase",
    "Conditions": "Condiciones",
    "Errors": {
      "Flight Date From Bigger": "Fecha de vuelo hasta debe ser igual o mayor que la fecha de vuelo desde",
      "Incorrect Airport Format": "Formato de aeropuerto incorrecto",
      "Incorrect Carrier Format": "Formato de carrier incorrecto",
      "Incorrect Class Format": "Formato de clase incorrecto",
      "Incorrect Fare Basis Format": "Formato de base de tarifa incorrecto",
      "Incorrect Flight Number Format": "Formato de número de vuelo incorrecto",
      "Length Minimum Airport": "El tamaño mínimo de aeropuerto son {{ quantityMax }} caracteres",
      "Length Minimum Carrier": "El tamaño mínimo del carrier son {{ quantityMax }} caracteres",
      "Length Minimum Fare Basis": "El tamaño mínimo de la base de tarifa son {{ quantityMax }} caracteres",
      "Mixed Condition Repeated": "La condición mixta ya existe",
      "Required Carrier": "El carrier es obligatorio",
      "Required Class": "La clase es obligatoria",
      "Required Fare Basis": "La base de tarifa es obligatoria",
      "Required Flight Date From": "Fecha desde es obligatoria",
      "Required Flight Date To": "Fecha hasta es obligatoria",
      "Required Flight Number From": "Nº vuelo desde obligatorio",
      "Required Flight Number To": "Nº vuelo hasta obligatorio",
      "The Following Carriers Were Not Found": "Los siguientes carriers no fueron encontrados: {{ param }}",
      "The Following Journeys Were Not Found": "Los siguientes destinos no fueron encontrados: {{ param }}"
    },
    "Exclusive": "Exclusivo",
    "Fare Basis": "Base de tarifa",
    "Fare Basis Class": "BASE DE TARIFA + CLASE",
    "Flight Date From": "Fecha Vuelo desde",
    "Flight Date To": "Fecha Vuelo hasta",
    "Flight Number From": "Nº vuelo desde",
    "Flight Number To": "Nº vuelo hasta",
    "Inclusive": "Inclusivo",
    "Indistinct": "Indistinto",
    "Saved Correctly": "Las condiciones mixtas han sido guardadas correctamente",
    "To": "Hasta"
  },
  "Modal":{
    "Confirmation": "Confirmación",
    "ConfirmDelete": "¿Estás seguro de que quieres borrar {{ param }}?",
    "Deleted": "Cuenta remota borrada",
    "Error": "Error",
    "Info": "Información",
    "Success": "Hecho",
    "Warning": "Aviso"
  },
  "primeng": {
    "clear": "Borrar",
    "dayNamesMin": ["Do","Lu","Ma","Mi","Ju","Vi","Sa"],
    "monthNames": ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre" ,"Noviembre", "Diciembre"],
    "monthNamesShort": ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sept", "Oct", "Nov", "Dic"],
    "today": "Hoy"
  },
  "RemoteAccounts": {
    "Administration": "Administración de Cuentas Remotas",
    "AirlineCode": "Aerolínea",
    "Cannot Delete Type": "No se puede borrar una cuenta de tipo db-ss o db-ifx",
    "CountryCode": "País",
    "Credential": "Credencial",
    "Credential LoginType Exists": "Ya existe una credencial para este tipo y con ese Login",
    "Customer Accelya Remote Shared": "Si el cliente es Accelya, el remoto debe ser compartido",
    "Customer Short Name": "Cliente",
    "CustomerHaveDb": "El cliente seleccionado ya tiene creada una base de datos",
    "Database Validation Credential": "Credential tiene que ser de tipo SQL Server o Informix",
    "Database Validation Remote": "Remoto tiene que ser de tipo SQL Server o Informix",
    "DbMaestro Same Country": "Ya existe una base de datos de tipo MAESTRO creada con el mismo país",
    "Description": "Descripción",
    "EditRemoteAccount": "Editar cuenta remota",
    "Error Connection When Deleting": "Error al intentar borrar la cuenta remota por fallo de conexión a la base de datos IPM para comprobar los pagos",
    "Error Deleting Database Types": "No se puede borrar cuentas remotas de tipo {{ type }}",
    "Error Deleting Remote Account": "Error al intentar borrar la cuenta remota",
    "Error Get Remote": "Error al recuperar un remoto",
    "Error Get Remote Account": "Error al recuperar una cuenta remota",
    "Error Get Remote Accounts": "Error al recuperar las cuentas",
    "Error Password Format": "El formato de la contraseña no es correcto",
    "Error Saving Remote Account": "Error al intentar guardar la cuenta remota",
    "Error Updating Remote Account": "Error al intentar actualizar la cuenta remota",
    "Expiration Date": "Fecha de expiración",
    "Incorrect Different RemoteUserType": "El tipo de remoto es diferente al tipo de la credencial",
    "Memo Periodic With Remote": "No se puede borrar la cuenta remota ya que el remoto {{ param }} está asociado a algunos pagos",
    "New Remote Account": "Nueva cuenta remota",
    "Remote Description": "Remoto",
    "Remote TypeHostPort Exists": "Ya existe un remoto para ese tipo, servidor y puerto",
    "Remote Use Type": "Tipo",
    "Saved": "La cuenta ha sido guardada satisfactoriamente",
    "Updated": "La cuenta ha sido actualizada satisfactoriamente"
  },
  "Reports": {
    "Conversion": "Convertir a:",
    "Download Report" : "Descargar informe",
    "Errors": {
      "Error Check Reports": "Por favor, revise los informes generados",
      "Error Deleting Report": "Error al borrar el informe",
      "Error Downloading Report": "Error al descargar el informe",
      "Error Generating Report": "Se ha producido un error al guardar el reporte",
      "Error Sending Report": "Error al enviar el informe"
    },
    "No Data To Filter": "No existen datos para poder crear un informe de billetes comisionados.",
    "Remove Report" : "Borrar informe",
    "Report Creation": "La creación de su informe puede tardar algunos minutos",
    "Report Generation": "El informe se ha comenzado a generar",
    "Report Keep Browsing": "Mientras tanto puede seguir navegando por la web y volver más tarde",
    "Report Submission": "Envío de informe",
    "Reports": "Informes",
    "Select Agents": "Seleccionar agentes",
    "Select Agents Groups": "Seleccionar grupos de agentes",
    "Select Airlines": "Seleccionar aerolíneas",
    "Select Contracts": "Seleccionar contratos",
    "Select Countries": "Seleccionar países",
    "Select Document Types": "Seleccionar tipos de documento",
    "Select Range": "Seleccionar fechas",
    "Send Report": "Enviar informe",
    "Volume": {
      "No Database Configured": "No hay una base de datos configurada"
    },
    "Warning": {
      "No Data" : "No se han obtenido resultados para el país seleccionado."
    }
  },
  "Table Commons": {
    "Clear": "Limpiar",
    "Clear Filter": "Limpiar filtro",
    "Not Found": "No se ha encontrado ningún registro",
    "Search Keyword": "Buscar palabra clave"
  },
  "Tableau": {
    "Administration": "Administración de Tableau",
    "Configuration Saved Successfully": "La configuración de Tableau se ha guardado correctamente",
    "Edit Global Configuration Confirmation": "Va a editar la configuración de Tableau para todos los clientes, ¿está seguro que quiere proceder?",
    "Error Getting Configuration": "Error al intentar recuperar la configuración de Tableau",
    "Error Saving Configuration": "Error al intentar guardar la configuración de Tableau",
    "Errors": {
      "Server Required": "El servidor es obligatorio",
      "Site Required": "El sitio es obligatorio"
    },
    "Project": "Proyecto",
    "Server": "Servidor",
    "Site": "Sitio",
    "Title": "Tableau",
    "View": "Vista"
  },
  "User": {
    "Accept Receive News Product": "Acepto recibir noticias acerca del producto",
    "Address": "Dirección",
    "City": "Ciudad",
    "Company Code": "Código compañía",
    "Company Name": "Nombre compañía",
    "Errors": {
      "Airline Code Only Numerics": "El código de aerolínea solo debe contener números",
      "City Only Letters": "La ciudad solo debe contener letras",
      "Country Only Letters And Numbers": "El país solo debe contener letras y/o números",
      "First Name Only Letters": "El nombre solo debe contener letras",
      "Last Name Only Letters": "Los apellidos solo deben contener letras",
      "Length Maximum Address": "El tamaño máximo para la dirección son {{ quantityMax }} caracteres",
      "Length Maximum City": "El tamaño máximo para la ciudad son {{ quantityMax }} caracteres",
      "Length Maximum Company": "El tamaño máximo para la empresa son {{ quantityMax }} caracteres",
      "Length Maximum Country": "El tamaño máximo para el país son {{ quantityMax }} caracteres",
      "Length Maximum FirstName": "El tamaño máximo para el nombre son {{ quantityMax }} caracteres",
      "Length Maximum LastName": "El tamaño máximo para los apellidos son {{ quantityMax }} caracteres",
      "Length Maximum Minimum Email": "El tamaño mínimo para el email son {{ quantityMin }} caracteres y máximo {{ quantityMax }}",
      "Length Maximum Phone": "El tamaño máximo para el teléfono son {{ quantityMax }} caracteres",
      "Length Maximum Position": "El tamaño máximo para el posición son {{ quantityMax }} caracteres",
      "Length Maximum State": "El tamaño máximo para la provincia son {{ quantityMax }} caracteres",
      "Length Maximum Zip": "El tamaño máximo para el código postal son {{ quantityMax }} caracteres",
      "Length Minimum Password": "El tamaño mínimo de la contraseña son {{ quantityMax }} caracteres",
      "Length Required IataCode": "El tamaño para el código de IATA tiene que ser de {{ quantityMax }} caracteres",
      "Required FirstName": "El nombre es obligatorio",
      "Required MFA Method": "MFA Método es obligatorio",
      "Reset Password": "Un error ha ocurrido al resetear la contraseña. Por favor, póngase en contacto con soporte",
      "State Only Letters": "El estado solo debe contener letras",
      "User Locked": "El usuario está bloqueado"
    },
    "First Name": "Nombre",
    "MFA Method": "Método MFA",
    "Phone": "Teléfono",
    "Position": "Posición",
    "Province": "Provincia",
    "Reset MFA": "Reiniciar MFA al conectarse la próxima vez",
    "Role": "Rol",
    "Save Profile": "Guardar perfil"
  },
  "Welcome Message": {
    "Error Getting": "Error al intentar recuperar el mensaje de bienvenida.",
    "Error Saving": "Error al intentar guardar el nuevo mensaje de bienvenida.",
    "HTML Format": "El mensaje de bienvenida no tiene formato HTML.",
    "Info Message": "Este mensaje será mostrado a todos los usuarios en la página de bienvenida.",
    "Multiple Messages": "Existe más de un mensaje de bienvenida guardado en la base de datos.",
    "Saved": "Un nuevo mensaje de bienvenida ha sido creado.",
    "Set Read": "El mensaje de bienvenida ha sido marcado como leído y no volverá a ser mostrado.",
    "Show Message": "Marcar el mensaje como leído y no volver a mostrarlo de nuevo.",
    "Tittle": "Mensaje de bienvenida"
  }
}
